<template>
  <div id="app">
    <!-- <keep-alive exclude="SpotPasttime,SpotRealtime"> -->
      <router-view
        :class="{
          blur:
            $store.state.spotModalShow ||
            ($store.state.childModalShow && $store.state.childModalCode)
        }"
      />
    <!-- </keep-alive> -->
    <SpotModal title="本省/市景区选择" v-if="$store.state.spotModalShow" />
    <KoubeiZhishuModal title="" v-if="$store.state.koubeiZhishuModalShow" />
    <ShishiyuqingDetail title="相关舆情事件分析" v-if="$store.state.lvyouyuqingxiangqingShow"/>

    <div>
      <QuntiHuaxiangDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '101'
        "
      />
      <ChuyouQuntiHuaxiangDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '201'
        "
      />
      <XianxiaXingweiFenxiDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '102'
        "
      />

      <XianshangXingweiFenxiDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '103'
        "
      />
      <YoukeliangGaikuangDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '104'
        "
      />

      <ChuyouXingweiFenxiDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '202'
        "
      />
      <!--资源评估详情-->
      <YetaiZiyuanFenxiDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '401'
        "
      />
      <JiaotongTongdaFenxiDatail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '404'
        "
      />
      <JiudianZiyuanFenxiDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '402'
        "
      />
      <JingquZiyuanFenxiDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '403'
        "
      />
      <GouwuShangquanFenxiDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '405'
        "
      />
      <!--景区口碑详情-->
      <JingquKoubeiDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '501'
        "
      />
      <YoukeQingxuFenxiDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '502'
        "
      />
      <ShujuLaiyuanDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '503'
        "
      />
      <CesuoDetail
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '504'
        "
      />
      <ScenicJingquKoubeiZhishu
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '505'
        "
      />
      <JingquKoubeiXiangxiPinglun
        v-if="
          $store.state.childModalShow && $store.state.childModalCode == '506'
        "
      />
      <PingCeGuanjianci
              v-if="
          $store.state.childModalShow && $store.state.childModalCode == '507'
        "
      />

      <YuqingliangqushiDetail
              v-if="
          $store.state.childModalShow && $store.state.childModalCode == '601'
        "
      />
      <YuqingleixingfenxiDetail
              v-if="
          $store.state.childModalShow && $store.state.childModalCode == '602'
        "
      />
      <FumianpingjiaguanjianciDetail
            v-if="
          $store.state.childModalShow && $store.state.childModalCode == '603'
        "
    />
      <ZhuyaoyuqinglaiyuanDetail
              v-if="
          $store.state.childModalShow && $store.state.childModalCode == '604'
        "
      />



    </div>
  </div>
</template>

<script>
import QuntiHuaxiangDetail from "@/components/Home/QuntiHuaxiangDetail.vue";
import YoukeliangGaikuangDetail from "@/components/Home/YoukeliangGaikuangDetail.vue";
import ChuyouQuntiHuaxiangDetail from "@/components/JuminChuyou/QuntiHuaxiangDetail.vue";
import XianxiaXingweiFenxiDetail from "@/components/Home/XianxiaXingweiFenxiDetail.vue";
import ChuyouXingweiFenxiDetail from "@/components/JuminChuyou/ChuyouXingweiFenxiDetail.vue";
import YetaiZiyuanFenxiDetail from "@/components/ZiyuanPinggu/YetaiZiyuanFenxiDetail.vue";
import JiaotongTongdaFenxiDatail from "@/components/ZiyuanPinggu/JiaotongTongdaFenxiDatail.vue";
import JiudianZiyuanFenxiDetail from "@/components/ZiyuanPinggu/JiudianZiyuanFenxiDetail.vue";
import JingquZiyuanFenxiDetail from "@/components/ZiyuanPinggu/JingquZiyuanFenxiDetail.vue";
import GouwuShangquanFenxiDetail from "@/components/ZiyuanPinggu/GouwuShangquanFenxiDetail.vue";

import XianshangXingweiFenxiDetail from "@/components/Home/XianshangXingweiFenxiDetail.vue";
import SpotModal from "@/components/SpotModal.vue";

import JingquKoubeiDetail from "@/components/JingquKoubei/JingquKoubeiDetail.vue";
import YoukeQingxuFenxiDetail from "@/components/JingquKoubei/YoukeQingxuFenxiDetail.vue";
import ShujuLaiyuanDetail from "@/components/JingquKoubei/ShujuLaiyuanDetail.vue";
import CesuoDetail from "@/components/JingquKoubei/CesuoDetail.vue";
import ScenicJingquKoubeiZhishu from "@/components/JingquKoubei/ScenicJingquKoubeiZhishu.vue";
import JingquKoubeiXiangxiPinglun from "@/components/JingquKoubei/JingquKoubeiXiangxiPinglun.vue";
import PingCeGuanjianci from "@/components/JingquKoubei/PingCeGuanjianci.vue";
import KoubeiZhishuModal from  "@/components/KoubeiZhishuModal.vue";
import YuqingliangqushiDetail from "@/components/Lvyouyulun/YuqingliangqushiDetail.vue";
import YuqingleixingfenxiDetail from "@/components/Lvyouyulun/YuqingleixingfenxiDetail.vue";
import FumianpingjiaguanjianciDetail from "@/components/Lvyouyulun/FumianpingjiaguanjianciDetail.vue";
import ZhuyaoyuqinglaiyuanDetail from "@/components/Lvyouyulun/ZhuyaoyuqinglaiyuanDetail.vue";
import ShishiyuqingDetail from "@/components/Lvyouyulun/ShishiyuqingDetail.vue";



export default {
  name: "App",
  components: {
    SpotModal,
    QuntiHuaxiangDetail,
    YoukeliangGaikuangDetail,
    ChuyouQuntiHuaxiangDetail,
    XianxiaXingweiFenxiDetail,
    ChuyouXingweiFenxiDetail,
    JingquKoubeiDetail,
    YoukeQingxuFenxiDetail,
    XianshangXingweiFenxiDetail,

    YetaiZiyuanFenxiDetail,
    JiaotongTongdaFenxiDatail,
    JiudianZiyuanFenxiDetail,
    JingquZiyuanFenxiDetail,
    GouwuShangquanFenxiDetail,
    ShujuLaiyuanDetail,
    CesuoDetail,
    ScenicJingquKoubeiZhishu,
    JingquKoubeiXiangxiPinglun,
    PingCeGuanjianci,
    KoubeiZhishuModal,

    YuqingliangqushiDetail,
    YuqingleixingfenxiDetail,
    FumianpingjiaguanjianciDetail,
    ZhuyaoyuqinglaiyuanDetail,
    ShishiyuqingDetail
  },
  mounted() {}
};
</script>

<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-size: 0.16rem;
  font-family: "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei", sans-serif;
  /* 文字抗锯齿渲染 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 禁止文字选中 */
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently not supported by any browser */
}
#app {
  width: 100%;
  height: 100%;
  text-align: center;
  color: @base-text-color;
  overflow: hidden;
  background: url(./assets/bg.jpg);
  background-size: 100% 100%;
}
.chart {
  width: 100% !important;
  height: 100% !important;
}
.child-detail {
  color: @base-text-color;
  .chart-title {
    font-size: 0.24rem;
    height: 0.24rem;
    margin-bottom: 0.36rem;
    font-weight: bold;
  }
  .line {
    width: 100%;
    height: 3rem;
    margin-bottom: 0.75rem;
    > div {
      width: 50%;
      padding: 0 0.7rem;
      box-sizing: border-box;
      height: 100%;
      float: left;
    }
  }
  .single-line {
    position: relative;
    margin-bottom: 0.75rem;
    min-height: 2rem;
  }
  .chart-content {
    margin: 0 auto;
    ol {
      width: 90%;
      height: 26px;
      margin: 0 auto 18px;
      li {
        float: left;
        width: 16.66%;
      }
      .current {
        color: @light-blue;
        border-bottom: 1px solid @light-blue;
        background-image: linear-gradient(
          to top,
          rgba(0, 84, 178, 0.4),
          rgba(34, 84, 178, 0.05)
        );
      }
    }
  }
}
</style>
